import {
    Box,
    Button,
    Divider, IconButton,
    TextField,
} from "@material-ui/core";

import {makeStyles} from '@material-ui/core/styles';
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {showAlertSnackbar} from "../../../reducers/uiSlice";
import {useTranslation} from "react-i18next";
import FullscreenLoading from "../../Common/FullscreenLoading";
import {DataGrid} from "@material-ui/data-grid";
import SelectBatchBar from "../SelectBatchBar";
import {Search} from "@material-ui/icons";
import {getOrderCountBySubBatch} from "../../../actions/workflowAction";

const useStyles = makeStyles((theme) => ({
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    verticalMargin: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    textSpace: {
        marginRight: theme.spacing(1)
    }
}))


export default function Views(props) {

    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [subBatch, setSubBatch] = useState(null);
    const [subBatchTyped, setSubBathTyped] = useState("");
    const [states, setStates] = useState([]);
    const [stateError, setStateError] = useState("");
    const [warehouses, setWarehouses] = useState([]);
    const [fullscreenLoading, setFullscreenLoading] = useState(false);
    const [airList, setAirList] = useState([]);
    const [airListDisplay, setAirListDisplay] = useState([]);
    const [selected, setSelected] = useState([]);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [minCount, setMinCount] = useState(0);


    const handleSubBatch = (subBatch) => {
        setSubBatch(subBatch);
    }

    const handleSubBatchTyped = (subBatchTyped) => {
        setSubBathTyped(subBatchTyped);
    }
    const handleStates = (states) => {
        setStates(states);
    }
    const handleStatesError = (stateError) => {
        setStateError(stateError);
    }
    useEffect(() => {
        if (props.open) {
            setAirList([]);
            setMinCount(0);
            setAirListDisplay([]);
        }
    }, [props.open])
    useEffect(() => {
        if (airList) {
            setAirListDisplay(airList);
        }
    }, [airList])
    useEffect(() => {
        if (subBatch !== null) {
            loadData(subBatch)
        }
    }, [subBatch])
    useEffect(() => {
        if (airList.length > 0) {
            let airListCurr = [];
            airList.map((air) => {
                if (air.count >= minCount) {
                    airListCurr.push(air);
                }
            })
            setAirListDisplay(airListCurr);
        }
    }, [minCount])

    const stepOneComplete = warehouses.length > 0 && stateError.length <= 0 && (subBatch !== null || subBatchTyped.length > 0)


    const columns = [
        {
            field: 'reference',
            headerName: t('reference'),
            width: 200,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'count',
            headerName: t('count'),
            width: 200,
            headerAlign: 'center',
            align: 'center'
        }
    ]

    return (
        <Box>

            <div className={classes.row} style={{marginBottom: 8}}>
                <SelectBatchBar stepOneComplete={stepOneComplete}
                                handleSubBatch={handleSubBatch}
                                handleSubBatchTyped={handleSubBatchTyped}

                                handleStates={handleStates}
                                handleStatesError={handleStatesError}/>
                {subBatchTyped.length > 0 ?
                    <IconButton onClick={() => {
                        loadData(subBatchTyped.trim())
                    }}>
                        <Search color='primary'/>
                    </IconButton>
                    :
                    null
                }
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <TextField
                        value={minCount}
                        variant='outlined'
                        label='Min Count'
                        onChange={(event) => {
                            setMinCount(event.target.value)
                        }}
                        disabled={airList.length <= 0}
                        style={{marginLeft: 10, maxWidth: 100}}
                    />
                    <Button
                        style={{marginLeft: 10}}
                        color="primary"
                        onClick={handleCopy}
                    >
                        {t('copy')}
                    </Button>
                </div>

            </div>
            <Divider/>
            <DataGrid
                loading={isDataLoading}
                style={{height: 500}}
                alignItems="center"
                rows={airListDisplay}
                columns={columns}
                pageSize={20}
                onSelectionModelChange={(newSelection) => {
                    setSelected(newSelection)
                }}
                checkboxSelection
            />
            <FullscreenLoading open={fullscreenLoading}/>
        </Box>
    )

    function handleCopy() {
        let selectedCurr = '';
        selected.map((id) => {
            selectedCurr += ',' + airList[id - 1].reference;
        })
        selectedCurr = selectedCurr.substring(1);
        navigator.clipboard.writeText(selectedCurr.toString())
        dispatch(showAlertSnackbar({title: 'Copy Batch', message: t('copy_success'), type: 'success'}))
    }
    function loadData(subBatch) {
        setIsDataLoading(true);
        dispatch(getOrderCountBySubBatch(subBatch))
            .then((res) => {
                setIsDataLoading(false);
                setAirList(res);

            })
    }

}